export const dateFormat = 'DD.MM.YYYY' as const
